import { Button, Title } from "@mantine/core";
import { ContextModalProps } from "@mantine/modals";

import { useDeleteOrderMutation } from "@/store";

type DeleteOrderProps = {
  id: number;
};
export function DeleteOrder({ context, id, innerProps }: ContextModalProps<DeleteOrderProps>) {
  const [deleteOrder, { isLoading }] = useDeleteOrderMutation();

  const handleDeny = () => {
    context.closeModal(id);
  };

  const handleConfirm = async () => {
    await deleteOrder({ id: innerProps.id });

    context.closeModal(id);
  };

  return (
    <div>
      <Title c="primary" order={2} ta="center" mb="md">
        Confirme a exclusão
      </Title>

      <div className="flex flex-col gap-4 text-center">
        <p>Tem certeza de que deseja excluir este pedido?</p>

        <div className="grid grid-cols-1 gap-1 md:grid-cols-2 md:gap-2">
          <Button onClick={handleDeny} variant="default" disabled={isLoading}>
            Cancelar
          </Button>

          <Button onClick={handleConfirm} color="red" loading={isLoading}>
            Confirmar
          </Button>
        </div>
      </div>
    </div>
  );
}
